import http from '../http'
import {API_CONFIG} from '../config'
import {AUTH_URL, LOGIN_URL, VERIFY_CODE_URL} from '../endpoints'

export function loginApi(authData) {
  return http.request({
    url: LOGIN_URL,
    method: 'POST',
    headers: {
      'Authorization': ""
    },
    data: {
      username: authData.username,
      password: authData.password,
      grant_type: 'password',
      client_id: API_CONFIG.CLIENT_ID,
      client_secret: API_CONFIG.CLIENT_SECRET,
      scope: ''
    }
  })
}

export function verifyCodeApi({ id, code }) {
  return http.request({
    url: VERIFY_CODE_URL(id),
    method: 'POST',
    headers: {
      'Authorization': ""
    },
    data: {
      code: code,
    }
  })
}
